import BasicRouterView from "../../components/BasicRouterView.vue";

const perfisRoutes = {
  path: "per",
  redirect: { name: "perfis-papeis" },
  meta: {
    label: "Perfis",
    icon: "manage_accounts",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "perfil/papel",
      name: "perfis-papeis",
      meta: {
        label: "Listar Papéis",
        icon: "list",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/ListaPapeis.vue"),
    },
    {
      path: "perfil/permissoes/:roleId",
      name: "perfis-permissoes",
      meta: {
        label: "",
        icon: "",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/ListaPermissoes.vue"),
    },
  ],
};

export default perfisRoutes;
